import { EnhancedDialogTitle, EnhancedDialogTitleProps, FlexSpacer } from '@insights-gaming/material-components';
import { Theme } from '@insights-gaming/theme';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React, { useMemo } from 'react';

interface MultiStepProductTourTitleOwnProps {
  className?: string;
  goToStep?: (step: number) => void;
  progress?: {
    current: number;
    total: number;
  };
}

type MultiStepProductTourTitleProps = MultiStepProductTourTitleOwnProps & EnhancedDialogTitleProps;

const useStyles = makeStyles<Theme, MultiStepProductTourTitleProps>(theme => createStyles({
  root: {
    '&$progress': {
      marginBottom: theme.spacing(1),
    },
  },
  title: {
    '&$progress': {
      transform: `translateY(${theme.spacing(1)}px)`,
    },
  },
  progressWrapper: {
    position: 'absolute',
  },
  progressDot: {
    backgroundColor: theme.palette.grey[700],
    width: 8,
    height: 8,
    borderRadius: '50%',
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shortest,
    }),
    '&$goToStep': {
      cursor: 'pointer',
    },
    '&$current': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  current: {},
  progress: {},
  goToStep: {},
}), { name: 'MultiStepProductTourTitle' });

export function MultiStepProductTourTitle(props: MultiStepProductTourTitleProps) {
  const classes = useStyles(props);
  const { children, className, goToStep, progress } = props;

  const total = progress?.total;
  const clickHandlers = useMemo(() => {
    if (!goToStep) {
      return [];
    }
    return Array.from({ length: total || 0 })
      .map((_, i) => () => goToStep(i));
  }, [goToStep, total]);

  return (
    <EnhancedDialogTitle
    variant='h5'
    {...props}
    className={classNames(classes.root, { [classes.progress]: progress }, className)}
    >
      <FlexSpacer orientation='vertical'>
        {progress && (
          <div className={classes.progressWrapper}>
            <FlexSpacer>
              {Array.from({ length: progress.total }).map((_, i) => (
                <div
                key={i}
                onClick={clickHandlers[i]}
                className={classNames(
                  classes.progressDot,
                  {
                    [classes.goToStep]: goToStep,
                    [classes.current]: i === progress.current,
                  },
                )}
                />
              ))}
            </FlexSpacer>
          </div>
        )}
        <div className={classNames(classes.title, { [classes.progress]: progress })}>
          {children}
        </div>
      </FlexSpacer>
    </EnhancedDialogTitle>
  );
}
